<template>
  <div class="success container">
    <img src="../../assets/crowdfunding/icon-check.svg" alt="">
    <div class="success__content">
      <h3 class="success__title">Thanks for your support</h3>
      <p class="success__text">
        Your pledge brings us one step closer to sharing Mastercraft Bamboo Monitor Riser worldwide.
        You will get an email once our campaign is completed.
      </p>
    </div>
    <div class="success__cta">
      <Button value="Got it" />
    </div>
  </div>
</template>

<script>
import Button from './reusable/Button.vue';

export default {
  components: {
    Button,
  },
};
</script>

<style lang="scss" scoped>
.success {
  position: absolute;
  top: 15rem;
  left: 0;
  right: 0;

  background-color: var(--white);

  box-shadow: 0 0 2px 0 var(--dark-gray);
  border-radius: var(--border-radius);
  padding: calc(var(--sm-spacer)) calc(var(--sm-spacer) - 0.5rem);

  text-align: center;
  max-width: calc(var(--text-width) / 1.5);

  img, &__title, &__text {
    margin-bottom: calc(var(--sm-spacer) / 1.5);
  }

  &__text {
    max-width: var(--text-width-sm);
  }

  &__title {
    font-size: var(--fs-h4);
    line-height: 1;
  }
}
</style>
